import React from "react";
import affiliations_logo2 from "../../assets/images/svg/affiliations_logo2.svg";
import affiliations_logo6 from "../../assets/images/svg/affiliations_logo6.svg";
import affiliations_logo7 from "../../assets/images/svg/affiliations_logo7.svg";
import affiliations_logo8 from "../../assets/images/svg/affiliations_logo8.svg";
import affiliations_logo9 from "../../assets/images/svg/affiliations_logo9.svg";
import affiliations_logo12 from "../../assets/images/svg/affiliations_logo12.svg";
import affiliations_logo13 from "../../assets/images/svg/affiliations_logo13.svg";
import affiliations_logo14 from "../../assets/images/svg/affiliations_logo14.svg";
import affiliations_logo15 from "../../assets/images/svg/affiliations_logo15.svg";
import affiliations_logo17 from "../../assets/images/svg/affiliations_logo17.svg";
import affiliations_logo18 from "../../assets/images/svg/affiliations_logo18.svg";

const logos = [
  affiliations_logo2,
  affiliations_logo6,
  affiliations_logo7,
  affiliations_logo8,
  affiliations_logo9,
  affiliations_logo12,
  affiliations_logo13,
  affiliations_logo14,
  affiliations_logo15,
  affiliations_logo17,
  affiliations_logo18,
];

// Two rows (6 + 5).
const rows = [logos.slice(0, 6), logos.slice(6)];

// Logo tiles bent along a curved screen. When it scrolls into view (AOS adds
// .aos-animate) the tiles fly in from deep inside it, centre first; a hovered
// tile lifts towards the viewer.
const Affiliations = () => (
  <div className="affiliations-section home-section-pad">
    <div className="container py-md-9 position-relative">
      <div className="row justify-content-center pb-md-5">
        <div className="col-md-11">
          <h3 data-aos="fade-up" className="section-heading">
            <span className="section-heading-accent">Affiliations</span>
          </h3>
          <p data-aos="fade-up" className="section-subtitle mb-5">
            Building Credibility Through Prestigious Industry Affiliations
          </p>

          <div className="af-screen" data-aos="af-build" data-aos-anchor-placement="center-bottom">
            {rows.map((row, r) => (
              <div className="af-row" key={r}>
                {row.map((logo, c) => {
                  // Distance from the row's centre: sets the tile's turn and its entry delay.
                  const a = c - (row.length - 1) / 2;
                  return (
                    <div className="af-tile" style={{ "--a": a, "--d": Math.abs(a) }} key={c}>
                      <img loading="lazy" decoding="async" src={logo} alt={`affiliation_logo_${r * 6 + c + 1}`} />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Affiliations;
